/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PURCHASE = `${url}/LOAD_PURCHASE`;
export const LOAD_PURCHASE_SUCCESS = `${url}/LOAD_PURCHASE_SUCCESS`;
export const LOAD_PURCHASE_ERROR = `${url}/LOAD_PURCHASE_ERROR`;
export const LOAD_DASHBOARD_TRANSACTION = `${url}/LOAD_DASHBOARD_TRANSACTION`;
export const LOAD_DASHBOARD_TRANSACTION_SUCCESS = `${url}/LOAD_DASHBOARD_TRANSACTION_SUCCESS`;
export const LOAD_DASHBOARD_TRANSACTION_ERROR = `${url}/LOAD_DASHBOARD_TRANSACTION_ERROR`;
export const LOAD_TOTAL_BALANCE = `${url}/LOAD_TOTAL_BALANCE`;
export const LOAD_TOTAL_BALANCE_SUCCESS = `${url}/LOAD_TOTAL_BALANCE_SUCCESS`;
export const LOAD_TOTAL_BALANCE_ERROR = `${url}/LOAD_TOTAL_BALANCE_ERROR`;

export const CREATE_PURCHASE = `${url}/CREATE_PURCHASE`;
export const CREATE_PURCHASE_SUCCESS = `${url}/CREATE_PURCHASE_SUCCESS`;
export const CREATE_PURCHASE_ERROR = `${url}/CREATE_PURCHASE_ERROR`;

//category
export const LOAD_PURCHASE_PARTIES_CATEGORY = `${url}/LOAD_PURCHASE_PARTIES_CATEGORY`;
export const LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS = `${url}/LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS`;
export const LOAD_PURCHASE_PARTIES_CATEGORY_ERROR = `${url}/LOAD_PURCHASE_PARTIES_CATEGORY_ERROR`;

export const CREATE_PURCHASE_PARTIES_CATEGORY = `${url}/CREATE_PURCHASE_PARTIES_CATEGORY`;
export const CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS = `${url}/CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS`;
export const CREATE_PURCHASE_PARTIES_CATEGORY_ERROR = `${url}/CREATE_PURCHASE_PARTIES_CATEGORY_ERROR`;

export const UPDATE_PURCHASE = `${url}/UPDATE_PURCHASE`;
export const UPDATE_PURCHASE_SUCCESS = `${url}/UPDATE_PURCHASE_SUCCESS`;
export const UPDATE_PURCHASE_ERROR = `${url}/UPDATE_PURCHASE_ERROR`;

export const DELETE_PURCHASE = `${url}/DELETE_PURCHASE`;
export const DELETE_PURCHASE_SUCCESS = `${url}/DELETE_PURCHASE_SUCCESS`;
export const DELETE_PURCHASE_ERROR = `${url}/DELETE_PURCHASE_ERROR`;

export const LOAD_PURCHASE_RECORDS_META_DATA = `${url}/LOAD_PURCHASE_RECORDS_META_DATA`;
export const LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS`;
export const LOAD_PURCHASE_RECORDS_META_DATA_ERROR = `${url}/LOAD_PURCHASE_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_PARTIES_TRANSACTION = `${url}/LOAD_PARTIES_TRANSACTION`;
export const LOAD_PARTIES_TRANSACTION_SUCCESS = `${url}/LOAD_PARTIES_TRANSACTION_SUCCESS`;
export const LOAD_PARTIES_TRANSACTION_ERROR = `${url}/LOAD_PARTIES_TRANSACTION_ERROR`;

// address update
export const LOAD_PARTY_VENDOR_ADDRESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_ERROR = `${url}/LOAD_PARTY_VENDOR_ADDRESS_ERROR`;

export const CREATE_PARTY_VENDOR_ADDRESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_ERROR = `${url}/CREATE_PARTY_VENDOR_ADDRESS_ERROR`;

const constants = {
  LOAD_PURCHASE,
  LOAD_PURCHASE_SUCCESS,
  LOAD_PURCHASE_ERROR,
  LOAD_DASHBOARD_TRANSACTION,
  LOAD_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_DASHBOARD_TRANSACTION_ERROR,
  LOAD_TOTAL_BALANCE,
  LOAD_TOTAL_BALANCE_SUCCESS,
  LOAD_TOTAL_BALANCE_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,

  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,

  LOAD_PURCHASE_PARTIES_CATEGORY,
  LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  LOAD_PURCHASE_PARTIES_CATEGORY_ERROR,

  CREATE_PURCHASE_PARTIES_CATEGORY,
  CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_PARTIES_CATEGORY_ERROR,

  CREATE_PURCHASE,
  CREATE_PURCHASE_SUCCESS,
  CREATE_PURCHASE_ERROR,

  UPDATE_PURCHASE,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_ERROR,

  DELETE_PURCHASE,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_PURCHASE_RECORDS_META_DATA,
  LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_RECORDS_META_DATA_ERROR,
};

export default constants;
